export default __webpack_public_path__ + "static/media/instagram.62991c8d.svg";